














































import Vue, { PropType } from "vue";

import DeviceStatusViewConfig from "./DeviceStatus/ViewConfig.vue";
import InstallationsStatusChangesTableViewConfig from "./InstallationsStatusChangesTable/ViewConfig.vue";

import CashCountViewConfig from "./CashCount/ViewConfig.vue";
import CashDistributionViewConfig from "./CashDistribution/ViewConfig.vue";
import TransactionsViewConfig from "./Transactions/ViewConfig.vue";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";

export default Vue.extend({
    components: {
        DeviceStatusViewConfig,
        InstallationsStatusChangesTableViewConfig,
        CashCountViewConfig,
        CashDistributionViewConfig,
        TransactionsViewConfig,
    },
    data() {
        return {
            WidgetTypesEnum,
            availableIcons: [
                "exclamation-triangle",
                "flag",
                "exclamation",
                "ban",
                "euro-sign",
                "coins",
                "money-bill-wave",
                "dollar-sign",
                "check-circle",
                "money-bill",
                "flag-checkered",
                "list-ul",
                "bell",
            ],
        };
    },
    computed: {
        availableViewTypes() {
            return this.widget.getAvailableViewType().map((v) => ({
                value: v.value,
                text: this.$t(v.text),
            }));
        },
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
});
